<template>
  <QS-scroller-box class="pr-0">
    <QS-h4-title title="车辆选择" />
    <form-text-box
      ref="vehicleSelection"
      :column="3"
      :dataList="createOrderInfo.list.c_vehicleSelectionList"
      :model="createOrderInfo.model.c_vehicleSelectionModel"
      :rules="createOrderInfo.rules.c_vehicleSelectionRules"
    />
    <!-- eslint-disable vue/no-unused-refs -->
    <form-text-box
      ref="vehicleInfo"
      :column="3"
      :dataList="createOrderInfo.list.c_vehicleInfoList"
      :model="createOrderInfo.model.c_vehicleInfomodel"
    />
    <!-- eslint-enable vue/no-unused-refs -->
    <template slot="bottomAction">
      <el-button @click="cancel" size="mini">取消</el-button>
      <el-button @click="previousStep" size="mini">上一步</el-button>
      <el-button :loading="confirmLoading" @click="confirm" size="mini" type="primary">确认，下一步</el-button>
    </template>
  </QS-scroller-box>
</template>
<script>
import { bindCarSignCheck } from '@/api/domain/carsService'
import { addPersonalOrderRenewalBSignCheck } from '@/api/domain/underLease'
import { FuzzySearch } from '@/api/purchaseAndSaleAPI'
import { isEmpty } from 'lodash'
import { mapState } from 'vuex'

export default {
  inject: ['getOrderConfigInfo'],
  props: {
    maitenaceParams: {
      type: Object,
      default: () => ({}),
    },
    tableDataFrom: {
      type: Object,
      default: () => ({}),
    },
    leaseInfoParams: {
      type: Object,
      default: () => ({}),
    },
    createOrderInfo: {
      type: Object,
      default: () => ({}),
    },
    leaseOrderDetailData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      from_check: {},
      confirmLoading: false,
      carList: [], // 车辆列表
    }
  },
  activated() {
    this.init()
  },
  mounted() {
    this.init()
  },
  methods: {
    // 更新车辆信息
    // eslint-disable-next-line vue/no-unused-properties
    plateNoChange(id) {
      const { c_vehicleInfomodel } = this.createOrderInfo.model
      if (id === '') {
        this.clearVehicleInfo()
        return
      }
      const selectCar = this.carList.find((item) => item.id === id)
      if (selectCar) {
        const { id: carId, carStateName, inventoryState } = selectCar
        c_vehicleInfomodel.carId = carId
        c_vehicleInfomodel.carStateName = carStateName
        c_vehicleInfomodel.inventoryStateName = inventoryState ? '在库' : '出库'
      }
    },
    // 清除车辆信息
    clearVehicleInfo() {
      const { c_vehicleInfomodel } = this.createOrderInfo.model
      c_vehicleInfomodel.carId = ''
      c_vehicleInfomodel.carStateName = ''
      c_vehicleInfomodel.inventoryStateName = ''
    },
    // 取消
    cancel() {
      this.$emit('cancel')
    },
    // 上一步
    previousStep() {
      this.$emit('previousStep')
    },
    // 确认
    async confirm() {
      this.$refs.vehicleSelection.getRefs().validate((valid) => {
        this.from_check.vehicleSelection = valid
      })
      // 校验所有表单是否通过
      const isfin = Object.keys(this.from_check).every(
        (item) => this.from_check[item],
      )
      if (!isfin) {
        this.$message.error('请先选择车辆')
        return
      }
      // source 1-后台 2-租赁商城
      // 商城下的单需要进行绑车操作
      const queryOrderId = this.$route.query?.orderId
      if (queryOrderId && Number(this.leaseOrderDetailData.source) === 2) {
        this.confirmLoading = true
        const params = this.getParameter()
        params.orderAccruedPlans = !isEmpty(params.orderAccruedPlans) ?
          params.orderAccruedPlans : this.orderConfigInfo.orderAccruedPlans

        params.customerId = params.customerId ?? this.orderConfigInfo.customerId
        params.startDate = params.startDate ?? this.orderConfigInfo.startDate
        params.endDate = params.endDate ?? this.orderConfigInfo.endDate
        // 去绑车
        const { code } = await bindCarSignCheck({ ...params, orderId: queryOrderId }).catch(() => { this.confirmLoading = false })
        this.confirmLoading = false
        if (code === 1) {
          if (queryOrderId) {
            this.$emit('confirm')
          } else {
            this.$router.replace({
              path: '/car_to_lease/forRentSignContract/personalSignContract',
              query: {
                orderId: queryOrderId,
              },
            })
          }
        }
      } else {
        this.getContractAdd()
      }
    },
    handleTopPreview(data) {
      const { topPreviewModel, c_vehicleSelectionModel } = this.createOrderInfo.model
      // 绑定车辆
      const vehicle = this.carList.find((item) => {
        return c_vehicleSelectionModel.plateNo === item.id
      })
      topPreviewModel.plateNo = vehicle?.plateNo || ''
      topPreviewModel.orderId = data.id
    },
    // 创建订单
    getContractAdd() {
      this.confirmLoading = true
      const params = this.getParameter()
      params.orderAccruedPlans = !isEmpty(params.orderAccruedPlans) ?
        params.orderAccruedPlans : this.orderConfigInfo.orderAccruedPlans

      params.customerId = params.customerId ?? this.orderConfigInfo.customerId
      params.startDate = params.startDate ?? this.orderConfigInfo.startDate
      params.endDate = params.endDate ?? this.orderConfigInfo.endDate
      addPersonalOrderRenewalBSignCheck({
        ...params,
        orderId: this.orderConfigInfo.orderId,
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          if (this.$route.query.orderId) {
            this.$emit('confirm')
          } else {
            this.$message({
              message: '合同添加成功',
              type: 'success',
            })
            this.$router.replace({
              path: '/car_to_lease/forRentSignContract/personalSignContract',
              query: {
                orderId: data.id,
              },
            })
          }
        }
        this.handleTopPreview(data)
        this.confirmLoading = false
      }).catch((error) => {
        this.confirmLoading = false
        if (error.code === 22049) {
          this.$message.error('租赁方案已下架，点击【上一步】重新选择租赁方案')
        }
      })
    },
    // 获取参数
    getParameter() {
      const { leaseInfoParams, createOrderInfo, tableDataFrom, maitenaceParams } = this
      const {
        // 选择客户节点
        c_baseInfoModel,
        c_customerInfoModel,
        // 租赁设置节点
        c_leaseSchemeModel,
        c_vehicleModelModel,
        // 车辆选择
        c_vehicleSelectionModel,
        c_vehicleInfomodel,
      } = createOrderInfo.model
      // eslint-disable-next-line vue/no-mutating-props
      this.leaseInfoParams.startDate = this.leaseInfoParams.startStopDate[0]
      // eslint-disable-next-line vue/no-mutating-props
      this.leaseInfoParams.endDate = this.leaseInfoParams.startStopDate[1]

      return {
        ...c_vehicleSelectionModel,
        ...c_vehicleInfomodel,
        ...c_leaseSchemeModel,
        ...c_vehicleModelModel,
        ...c_baseInfoModel,
        ...c_customerInfoModel,
        ...maitenaceParams,
        ...leaseInfoParams,
        rentCategory: leaseInfoParams.rentCategory || leaseInfoParams.category,
        orderAccruedPlans: tableDataFrom.tableData || [],
        clueId: this.createOrderInfo.model.topPreviewModel.leadId,
      }
    },
    async init() {
      // 获取车辆列表
      this.plateNoRemoteMethod(true)
    },
    async plateNoRemoteMethod(notClearCar) {
      const { modelId } = this.createOrderInfo.model.topPreviewModel
      const { readyLeaseState } = this.createOrderInfo.model.c_vehicleSelectionModel

      //  车牌号为空时，清除下面车辆信息
      if (!this.createOrderInfo.model.c_vehicleSelectionModel.plateNo) {
        this.clearVehicleInfo() // 清除车辆信息
      }


      // eslint-disable-next-line vue/no-mutating-props
      !notClearCar && (this.createOrderInfo.model.c_vehicleSelectionModel.plateNo = '')

      // 如果modelId为空则不请求FuzzySearch接口
      if (!modelId && !this.orderConfigInfo.modelId) return

      const { data } = await FuzzySearch({
        state: 3, // 待租
        modelId: modelId || this.orderConfigInfo.modelId,
        readyLeaseState,
        orderId: this.orderConfigInfo.orderId,
      })
      this.carList = data
      this.$refs.vehicleSelection.setItemData({ elConfigKey: 'list', key: 'plateNo', data })
    },
  },
  computed: {
    orderConfigInfo() {
      return this.getOrderConfigInfo()
    },
    ...mapState({
      categoryList: (state) => {
        return state.global.categoryList
      },
    }),
  },
  watch: {
    orderConfigInfo: {
      async handler(info) {
        const { c_vehicleSelectionModel, topPreviewModel } = this.createOrderInfo.model
        await this.plateNoRemoteMethod()
        c_vehicleSelectionModel.plateNo = info.carId
        this.plateNoChange(info.carId)
        // 获取租赁模式
        if (isEmpty(this.categoryLis)) await this.$store.dispatch('getPaymentMethods', { type: 'rentCategory' })
        const category = this.categoryList.find((item) => item.code === info.rentCategory)
        topPreviewModel.categoryName = category?.name
      },
    },
  },
}
</script>
<style lang="scss" scoped>
.pr-0 {
  padding-right: 0;
  ::v-deep .scrollerBox-content {
    padding-right: 0;
  }
}
</style>
